import React from "react";
import { DataGrid, GridColDef } from "@mui/x-data-grid";
import { ApiResponse } from "../../../services/api";
import User from "../../../types/user";

interface UserTableProps {
  rows: any[];
  columns: GridColDef[];
  height?: number;
  width?: string;
  getRowClassName?: (params: { indexRelativeToCurrentPage: number }) => string; 
  apiResponse: ApiResponse<User> | null;
  paginationModel: any; 
  setPaginationModel: any;
}

const UserTable: React.FC<UserTableProps> = ({
  rows,
  columns,
  height = 550,
  width = "100%",
  getRowClassName,
  apiResponse,
  paginationModel,
  setPaginationModel,
}) => {
  const computedHeight = height;

  return (
    <div style={{ height: computedHeight, width }}>
      <DataGrid
        rows={rows}
        columns={columns}
        initialState={{
          pagination: {
            paginationModel: { pageSize: 100 },
          },
        }}
        pageSizeOptions={[10, 20, 50, 100]}
        pagination
        checkboxSelection={false}
        getRowClassName={getRowClassName}
        paginationModel={paginationModel}
        onPaginationModelChange={setPaginationModel}
        sx={{
          "& .MuiDataGrid-row:nth-of-type(even)": {
            backgroundColor: "#f5f5f5",
          },
          "& .MuiDataGrid-row:nth-of-type(odd)": {
            backgroundColor: "white",
          },
          "& .MuiDataGrid-row:hover": {
            backgroundColor: "#b2d1ff",
          },
          "& .MuiTablePagination-selectLabel": {
            marginTop: "14px",
          },
          "& .MuiTablePagination-displayedRows": {
            marginTop: "14px",
          },
          "& .MuiDataGrid-cell[id='id']": {
            cursor: "pointer !important",
          },
          "& .MuiDataGrid-cell:focus, & .MuiDataGrid-cell:focus-within": {
            outline: "none",
          },
          "& .MuiDataGrid-row:focus, & .MuiDataGrid-row:focus-within": {
            outline: "none",
          },
        }}
      />
    </div>
  );
};

export default UserTable;
